module.exports = __webpack_public_path__ + "img/garbage-truck.df786650.svg";